let index = 0
const faderContent = document.getElementById('fader-content')

function getFader() {
  return document.getElementById('fader')
}

function fadeNext() {
  const fader = getFader()
  if (fader.children.length > 0)
    fadeOut(fader.children[0], () => doFade(fader))
  else doFade(fader)
}

function doFade(fader) {
  const children = faderContent.children
  const maxIndex = children.length - 1

  const clone = cloneElement(index, children)
  fader.replaceChildren(clone)

  fadeIn(clone, fadeNext)
  index = index === maxIndex ? 0 : index + 1
}

function cloneElement(index, elements) {
  const clone = elements[index].cloneNode(true)
  clone.style.opacity = 0

  return clone
}

function fadeIn(element, callback) {
  element.style.transition = 'opacity 5s ease'

  // Double requestAnimationFrame to paint the initial opacity, then paint the opacity change
  requestAnimationFrame(() => {
    requestAnimationFrame(() => element.style.opacity = 1)
  })
  element.addEventListener('transitionend', callback, { once: true })
}

function fadeOut(element, callback) {
  element.style.transition = 'opacity 2s ease'

  // Double requestAnimationFrame to paint the initial opacity, then paint the opacity change
  requestAnimationFrame(() => {
    requestAnimationFrame(() => element.style.opacity = 0)
  })
  element.addEventListener('transitionend', callback, { once: true })
}

function isPresent() {
  return !!document.getElementById('fader-content')
}

export default { isPresent, animateContent: fadeNext }